import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=785b3c5d"
import script from "./EventList.js?vue&type=script&lang=js&external"
export * from "./EventList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports